import { Component, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { RecurrenceEditorModule } from '@syncfusion/ej2-angular-schedule'
import { disallowInfiniteRecurrenceInDropdown } from '../../../scheduling/EjsScheduleHelper'
import { RruleHelper } from '../../../recurrence/rruleHelper'

@Component({
  selector: 'app-assistance-editor-recurrence-editor',
  templateUrl: './assistance-editor-recurrence-editor.component.html',
  styleUrls: ['./assistance-editor-recurrence-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssistanceEditorRecurrenceEditorComponent),
      multi: true,
    },
  ],
  imports: [RecurrenceEditorModule],
})
export class AssistanceEditorRecurrenceEditorComponent implements OnChanges, ControlValueAccessor {
  // If present, the time portion of this variable will be used to align UNTIL portion of the resulting RRULE to a specific time
  @Input() intendedTimeForUNTIL: Date

  protected _value: string // rrule string
  public disabled: boolean
  private _onChange: (value: string) => void
  protected _onTouched: () => void
  private currentRecurrenceType: string

  private TAG = 'AssistanceEditorRecurrenceEditorComponent'
  private isInitialized: boolean = false

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('intendedTimeForUNTIL')) {
      if (
        changes.intendedTimeForUNTIL.currentValue?.getTime() !== changes.intendedTimeForUNTIL.previousValue?.getTime()
      ) {
        this.setUNTILTime(changes.intendedTimeForUNTIL.currentValue)
        if (this._value !== undefined) this._onChange(this._value)
      }
    }
  }

  registerOnChange(fn: any): void {
    this._onChange = fn
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
  writeValue(value: string): void {
    console.log(this.TAG, 'writeValue', value)
    this._value = value
  }

  onChangeInternal(event: any) {
    console.log(this.TAG, 'onChangeInternal', event)
    this.currentRecurrenceType = disallowInfiniteRecurrenceInDropdown(event, this.currentRecurrenceType)
    this._value = event.value
    this.setUNTILTime(this.intendedTimeForUNTIL)
    if (this.isInitialized) {
      this._onChange(this._value)
    } else {
      this.isInitialized = true
    }
  }

  private setUNTILTime(intendedTime: Date) {
    if (!this._value) return
    if (!intendedTime) return

    const hour = intendedTime.getUTCHours()
    const minute = intendedTime.getMinutes()
    this._value = RruleHelper.changeTimeInRruleUntil(this._value, hour, minute)
  }
}
